import React from "react";

import style from "css/workspace.module.css";
import Main from "./detail/main";
import Telehealth from "./detail/telehealth";
import TeleRounding from "./detail/teleRounding";
import Teleconsolution from "./detail/teleconsolution";
import Symposium from "./detail/symposium";
import { Route, Routes, useLocation } from "react-router-dom";
function TelehealthMain() {
  return (
    <div className={style.fontsize}>
      <Routes>
        <Route path="telehealth" element={<Telehealth />} />
        <Route path="telerounding" element={<TeleRounding />} />
        <Route path="teleconsolution" element={<Teleconsolution />} />
        <Route path="symposium" element={<Symposium />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </div>
  );
}

export default TelehealthMain;
